export default "__VITE_ASSET__CrKnulgQ__"